// src/pages/NeuerServicePartnerPage.jsx
import ServicePartnerForm from "../components/servicepartner/ServicePartnerForm";

export default function NeuerServicePartnerPage() {
  return <ServicePartnerForm />;
}